var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGraphicUserSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 115,
  height: 98
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "graphic-user-success_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h115v98H0z",
  "data-name": "Rectangle 3183"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#graphic-user-success_svg__a)",
  "data-name": "Group 6282"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#eef0f2",
  d: "M50.506 96.623c-35.622.759-57.357-20.858-48.547-48.285S39.64.063 66.453 1.781 115 25.115 115 50.066s-28.873 45.8-64.494 46.558",
  "data-name": "Path 5464"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#004049",
  d: "M73.235 48.402c-4.594 0-6.8 2.547-14.342 2.547s-9.733-2.547-14.343-2.547a21.46 21.46 0 0 0-21.513 21.4v4.07a7.665 7.665 0 0 0 7.683 7.642h56.345a7.665 7.665 0 0 0 7.684-7.642v-4.075a21.46 21.46 0 0 0-21.514-21.4m13.83 25.473H30.716v-4.073a13.817 13.817 0 0 1 13.83-13.756c2.337 0 6.131 2.548 14.342 2.548 8.276 0 11.99-2.548 14.342-2.548a13.817 13.817 0 0 1 13.83 13.756ZM58.892.002a22.926 22.926 0 1 0 23.05 22.926A22.994 22.994 0 0 0 58.892.002m0 38.21a15.284 15.284 0 1 1 15.367-15.284 15.35 15.35 0 0 1-15.367 15.284",
  "data-name": "Path 5465"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M74.26 22.926A15.367 15.367 0 1 1 58.893 7.642 15.35 15.35 0 0 1 74.26 22.926",
  "data-name": "Path 5466"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#499f88",
  d: "M87.069 69.797v4.075H30.721v-4.075a13.817 13.817 0 0 1 13.83-13.756c2.337 0 6.131 2.548 14.342 2.548 8.276 0 11.99-2.548 14.342-2.548a13.817 13.817 0 0 1 13.83 13.756",
  "data-name": "Path 5467"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#35df90",
  d: "M106.385 68.015a17.055 17.055 0 0 1 0 24.212 17.28 17.28 0 0 1-24.343 0 17.055 17.055 0 0 1 0-24.212 17.28 17.28 0 0 1 24.343 0",
  "data-name": "Path 5468"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M85.281 80.73a.95.95 0 0 1 0-1.346l1.353-1.346a.96.96 0 0 1 1.354 0l4.19 4.168 8.976-8.927a.96.96 0 0 1 1.353 0l1.353 1.346a.95.95 0 0 1 0 1.346L92.859 86.917a.96.96 0 0 1-1.354 0Z",
  "data-name": "Path 5469"
}))));
export default SvgGraphicUserSuccess;